module.exports = __webpack_public_path__ + "icon_team_someone_gray.3eeb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_team_someone_gray.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_team_someone_gray.svg
// module chunks = main